/* eslint-disable no-useless-computed-key */
/* eslint-disable prefer-object-spread */
/* eslint-disable import/extensions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable import/prefer-default-export */

import React, { memo, useCallback, useMemo } from 'react';
import {
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Button,
  Col,
  FormGroup,
  Input,
  Label,
} from 'reactstrap';
import { toast } from 'react-toastify';
import Dropzone from 'react-dropzone';

import upload from '../../../../Res/Icon/Upload.png';
import remove from '../../../../Res/Icon/remove.png';
import { TAB_ACTION } from '../../constants';
import CustomDropzone from '../../../CustomDropzone';

const AddEditModalBody = memo(
  ({
    onConfirm,
    editNote,
    onEditNote,
    closeModal,
    data,
    setData,
    updateFetchQuery,
    selectedTab,
  }) => {
    const { note, uploadedFile, selectedBox } = data;

    const isFileAttached = useMemo(() => !!uploadedFile.name, [uploadedFile]);
    const isSelectedTabSystem = useMemo(
      () => selectedTab.toString() === TAB_ACTION.DEVICE_ACTIVITY.toString() && editNote,
      [],
    );

    const clearStates = useCallback((close = true) => {
      setData({ note: '', uploadedFile: {}, selectedBox: {} });
      if (close) closeModal();
    }, []);

    const handleConfirmation = useCallback(async () => {
      if (!note && !isFileAttached) {
        toast.error('Please enter note or attachemnt');
        return;
      }
      const type = uploadedFile.name ? 'userWithAttachment' : 'user';
      await onConfirm({ note, file: isFileAttached ? uploadedFile : '', type });
      await updateFetchQuery();
      clearStates();
    }, [note, isFileAttached, uploadedFile]);

    const handleConfirmEdit = useCallback(async () => {
      if (!note && !isFileAttached) {
        toast.error('Please enter note or attachemnt');
        return;
      }
      await onEditNote({ ...selectedBox, note, file: uploadedFile }, selectedBox._id);
      await updateFetchQuery();
      clearStates();
    }, [note, isFileAttached, uploadedFile, selectedBox]);

    const handleUploadAttachment = useCallback(
      e => {
        const _shallowCopy = { ...data, ['uploadedFile']: e[0] };
        setData(_shallowCopy);
      },
      [data],
    );

    const removeAttachement = useCallback(() => {
      let _shallowCopy = {};
      if (editNote) {
        const selectedBox_ = { ...selectedBox };
        selectedBox_.attachment = { name: '', path: '' };
        _shallowCopy = { ...data, selectedBox: selectedBox_, uploadedFile: {} };
        setData(_shallowCopy);
        return;
      }
      _shallowCopy = { ...data, uploadedFile: {} };
      setData(_shallowCopy);
    }, []);

    const renderFiles = e => {
      return (
        <div className="notes-file-item">
          {isSelectedTabSystem ? null : (
            <>
              <span className="item">{e.name}</span>
              <img className="remove-icon" src={remove} onClick={removeAttachement} alt="remove" />
            </>
          )}
        </div>
      );
    };

    const renderUploadContainer = () => {
      return (
        <>
          {isSelectedTabSystem ? null : (
            <CustomDropzone
              onFileChange={ev => {
                handleUploadAttachment(ev);
                }}
              files={uploadedFile}
            />
          )}
        </>
      );
    };

    return (
      <div className="container">
        <Row>
          <Col md={12} sm={12}>
            <FormGroup row>
              <Label for="model" sm={8}>
                Note
              </Label>
              <Col sm={12} style={{ display: 'flex' }}>
                <Input
                  required
                  type="textarea"
                  name="note"
                  placeholder="Enter Note"
                  value={note}
                  onChange={e => {
                    setData({ ...data, note: e.target.value });
                  }}
                />
                {editNote ? (
                  <Button
                    color="primary"
                    style={{ marginLeft: '10px' }}
                    onClick={handleConfirmEdit}
                  >
                    Edit Note
                  </Button>
                ) : (
                  <div style={{ display: 'flex' }}>
                    <Button
                      color="primary"
                      style={{ marginLeft: '10px' }}
                      onClick={handleConfirmation}
                    >
                      Add Note
                    </Button>
                  </div>
                )}
              </Col>
            </FormGroup>
            {isFileAttached ? renderFiles(uploadedFile) : renderUploadContainer()}
          </Col>
        </Row>
      </div>
    );
  },
);

export const AddEditModal = memo(
  ({
    mode = 'ADD',
    isOpen,
    handleModal,
    onConfirm,
    data,
    setData,
    onEditNote,
    updateFetchQuery,
    selectedTab,
  }) => {
    const closeModal = () => {
      handleModal(false);
    };

    return (
      <>
        <Modal isOpen={isOpen} toggle={closeModal} className="create-box-modal">
          <ModalHeader>{mode === 'ADD' ? <>Add</> : <>Edit</>} Note</ModalHeader>
          <ModalBody>
            <AddEditModalBody
              onConfirm={onConfirm}
              editNote={!!mode.includes('EDIT')}
              closeModal={closeModal}
              data={data}
              setData={setData}
              onEditNote={onEditNote}
              updateFetchQuery={updateFetchQuery}
              selectedTab={selectedTab}
            />
          </ModalBody>
        </Modal>
      </>
    );
  },
);
